module.exports = __webpack_public_path__ + "static/media/ss3.0633f979.jpg";